




















import Vue from 'vue';
import Component from 'vue-class-component';
import * as VueCarousel from 'vue-carousel';

@Component({
  components: {
    Carousel: VueCarousel.Carousel,
    Slide: VueCarousel.Slide,
  },
})
export default class ImageSlider extends Vue {
  protected slides: string[] = [
    require('@/assets/images/slider-01.jpg'),
    require('@/assets/images/slider-02.jpg'),
    require('@/assets/images/slider-03.jpg'),
  ];
}
